import { useThemeContext } from 'app/theme/useThemeContext';
import { useMemo } from 'react';

export const useDefaultYAxis = () => {
  const theme = useThemeContext();
  return useMemo(() => {
    return {
      labels: {
        style: {
          color: theme.colors.mono.ui06,
          fontSize: `${theme.font.size.md}rem`,
        },
        enabled: true,
      },
      tickColor: theme.colors.mono.ui06,
      title: {
        text: '',
        style: {
          color: theme.colors.mono.ui06,
          fontSize: `${theme.font.size.md}rem`,
        },
      },
      endOnTick: true,
      gridLineColor: theme.colors.mono.ui04,
      opposite: undefined,
    };
  }, [theme]);
};
